export default __webpack_public_path__ + "static/media/banner8.f29efd00.png";